"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RelativeToHelper_1 = require("../../../DOM/HTMLElement/RelativeTo/RelativeToHelper");
(() => {
    HTMLElement.prototype.setRelativeTo = function setRelativeTo(element, alignments, relativeParent, options) {
        var _a, _b;
        this.style.left = '0px';
        this.style.top = '0px';
        if ((options === null || options === void 0 ? void 0 : options.autoHeight) === true) {
            this.style.width = '';
            this.style.overflowY = '';
            this.style.maxHeight = '';
        }
        const detectViewport = (options === null || options === void 0 ? void 0 : options.detectViewport) !== false;
        // calculate rectangles. `this` element must be hidden for calculations to be correct
        const rectRelativeTo = RelativeToHelper_1.default.hide(this, () => RelativeToHelper_1.default.getCoordinates(element, relativeParent));
        const rectVisible = RelativeToHelper_1.default.hide(this, () => RelativeToHelper_1.default.getVisibleRectangle(relativeParent, detectViewport));
        let rectContainer = RelativeToHelper_1.default.getCoordinates(this);
        // adjust this.height according to available space in the viewport
        if ((options === null || options === void 0 ? void 0 : options.autoHeight) === true) {
            rectContainer = RelativeToHelper_1.default.adjustHeightToViewport(this, element, rectContainer, rectVisible, alignments);
        }
        const bestPosition = RelativeToHelper_1.default.getBestPositionWithinViewport(alignments, (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : {}, rectContainer, rectRelativeTo, rectVisible);
        this.style.position = 'absolute';
        this.style.left = (bestPosition.point.x - rectContainer.left) + 'px';
        this.style.top = (bestPosition.point.y - rectContainer.top) + 'px';
        // istanbul ignore next
        return (_b = bestPosition.align) !== null && _b !== void 0 ? _b : '';
    };
})();
//# sourceMappingURL=SetRelativeTo.js.map